var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import Vue from 'vue';
import Sidebar from 'ui/v1/Sidebar.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import SlideConfirmation from 'components/ui/SlideConfirmation.vue';
import UiContentMenu from 'ui/v1/navigation/UiContentMenu.vue';
import UiContentLink from 'ui/v1/navigation/UiContentLink.vue';
var NotificationsApp = /** @class */ (function (_super) {
    __extends(NotificationsApp, _super);
    function NotificationsApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationsApp = __decorate([
        Component({
            components: {
                UiContentLink: UiContentLink,
                UiContentMenu: UiContentMenu,
                SlideConfirmation: SlideConfirmation,
                Sidebar: Sidebar,
                Icon: Icon,
            },
            metaInfo: function () {
                return {
                    title: this.$t('notifications.notification_center'),
                };
            },
        })
    ], NotificationsApp);
    return NotificationsApp;
}(Vue));
export default NotificationsApp;
